import React from 'react';
import Stack from '@mui/material/Stack';
import {Body, Button, Headline} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {getApprovalStepDisplayName} from '@/views/campaigns/constants/approvalSteps';
import Modal from '@/components/modal';
import type {ActionModalProps} from '@/hooks/use-content-submission-action/useContentSubmissionAction';
import useContentSubmissionOffPlatformIdentityStore from '@/stores/contentSubmissionOffPlatformIdentityStore';
import styles from './ApproveContentSubmissionModal.module.scss';

function OffPlatformApproveModal({
  isOpen,
  onClose,
  onConfirm,
  campaignId,
}: ActionModalProps) {
  const identity = useContentSubmissionOffPlatformIdentityStore(
    (s) => s.identities[campaignId] ?? null
  );
  const role = identity?.role ?? '';
  const roleDisplayName = getApprovalStepDisplayName(role);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size="small"
      contentClassName={styles.modalContent}
    >
      <Stack direction="column" className={styles.content}>
        <Headline size="md" className={styles.title}>
          {translate('Approve as {role}', {role: roleDisplayName})}
        </Headline>
        <Body size="md" className={styles.subtitle}>
          {translate('off-platform-approve-confirmation', {
            role: roleDisplayName,
          })}
        </Body>
        <Stack direction="row" className={styles.actions}>
          <Button
            appearance="neutral"
            mode="tinted"
            size="large"
            onClick={onClose}
          >
            {translate('Cancel')}
          </Button>
          <Button
            appearance="neutral"
            mode="filled"
            size="large"
            onClick={() => onConfirm()}
          >
            {translate('Approve')}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}

export default OffPlatformApproveModal;
